import type { ExtensionConfig } from '@goto/shell'

const baseUrl = '/experiences/cc-config'

const extensionConfig: ExtensionConfig = {
  id: '@ucc/cc-config/extension',
  url: new URL(`${baseUrl}/extension.js`, location.origin),
}

export default extensionConfig
